import React, { ChangeEvent, MutableRefObject } from 'react';
import TextInputBase from './text-input-base';

export interface ITextInputProps {
    name: string;
    label: string;
    innerRef?: MutableRefObject<HTMLInputElement | null>;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    maxLength?: number;
    placeholder?: string;
    value?: string | number;
    title?: string;
    error?: string;
    warning?: boolean;
    showError?: boolean;
    required?: boolean;
    labelClassName?: string;
    fieldClassName?: string;
    elementClassName?: string;
    groupAddOnBefore?: JSX.Element | string;
    groupAddOnAfter?: JSX.Element | string;
    disabled?: boolean;
    onBlur?: (event: ChangeEvent<HTMLInputElement>) => void;
    onKeyDown?: (event: React.KeyboardEvent<HTMLElement>) => void;
    customLabel?: boolean;
    toolTipMessage?: string;
    isOldStyleRequired?: boolean;
}

const TextInput = ({
    name,
    label,
    onChange,
    maxLength,
    placeholder,
    value,
    title,
    error,
    warning,
    showError,
    required,
    labelClassName,
    fieldClassName,
    groupAddOnBefore,
    groupAddOnAfter,
    elementClassName,
    onBlur,
    onKeyDown,
    customLabel,
    toolTipMessage,
    disabled,
    isOldStyleRequired,
    innerRef,
}: ITextInputProps) => {
    return (
        <TextInputBase
            type="text"
            name={name}
            label={label}
            onChange={onChange}
            value={value || ''}
            title={title}
            placeholder={placeholder}
            maxLength={maxLength}
            required={required}
            error={error}
            warning={warning}
            showError={showError}
            labelClassName={labelClassName}
            fieldClassName={fieldClassName}
            groupAddOnBefore={groupAddOnBefore}
            groupAddOnAfter={groupAddOnAfter}
            elementClassName={elementClassName}
            onBlur={onBlur}
            onKeyDown={onKeyDown}
            customLabel={customLabel}
            toolTipMessage={toolTipMessage}
            disabled={disabled}
            isOldStyleRequired={isOldStyleRequired}
            innerRef={innerRef}
        />
    );
};

export default TextInput;
